import { DateUtils, FeedItemDoc, FeedItemSubType, FeedItemType } from 'common';
import { ConcourseDb } from '../ConcourseDb';

export class FeedService {
  static migrateItems(feedItems: FeedItemDoc[]): FeedItemDoc[] {
    return feedItems.map(item => {
      const itemDate = DateUtils.fromISO(item.date);
      if (itemDate > DateUtils.currentDate) {
        itemDate.setFullYear(itemDate.getFullYear() - 1);
        return { ...item, date: itemDate.toISOString() };
      }
      return item;
    });
    /*
    const filesFixed: FeedItemDoc[] = feedItems
      .filter(item => item.sub === FeedItemSubType.FILE && item.sub_id == null)
      .map(item => {
        return { ...item, sub_id: item.related_id };
      });

    const scheduleFixed: FeedItemDoc[] = feedItems
      .filter(item => !item.type || item.type.toString() === 'task')
      .map(item => {
        return { ...item, type: FeedItemType.SCHEDULE };
      });

    return filesFixed.concat(scheduleFixed);
    */
  }


  static getDb(projectId: string): ConcourseDb {
    return ConcourseDb.getInstance(`p-${projectId}-feed`);
  }

  static newFeedItem(
    userId: string,
    type: FeedItemType,
    relatedId: string,
    sub: FeedItemSubType,
    subId: string = null,
    text: string = null
  ): FeedItemDoc {
    console.log('newFeedItem' + DateUtils.currentIso, userId, type, relatedId, sub, subId, text);
    return {
      _id: ConcourseDb.makeShortDocId(),
      user_id: userId,
      date: DateUtils.currentIso,
      type: type,
      related_id: relatedId,
      sub: sub,
      sub_id: subId,
      text: text
    };
  }

  static async deleteFeedItem(projectId: string, userId:string, itemId: string): Promise<FeedItemDoc> {
    const db = ConcourseDb.getInstance(`p-${projectId}-feed`);
    const doc = await db.getDoc(itemId);
    return await db.saveDoc({ ...doc, deleted_by: userId, deleted_date: DateUtils.currentIso });
  }
/*
  static newDeleteFeedItem(userId: string, item: FeedItemDoc): FeedItemDoc {
    console.log('newDeleteFeedItem' + DateUtils.currentIso, userId, item);
    return {
      _id: ConcourseDb.makeShortDocId(),
      user_id: userId,
      date: DateUtils.currentIso,
      type: item.type,
      related_id: item.related_id,
      sub: item.sub,
      sub_id: item.sub_id,
      delete_id: item._id,
    };
  }
    */

  static async storeFeedItem(projectId: string, item: FeedItemDoc): Promise<FeedItemDoc> {
    const db = ConcourseDb.getInstance(`p-${projectId}-feed`);
    return new Promise(async (resolve, reject) => {
      if (db.awaitingInitialSync) {
        db.on('complete', async docs => {
          resolve(await db.saveDoc(item));
        });
      } else {
        resolve(await db.saveDoc(item));
      }
    });
  }

  static filterFeedItems(feed: FeedItemDoc[], type: FeedItemSubType): FeedItemDoc[] {
    const feedOfType = feed.filter(f => f.sub == type);
    return feedOfType.filter(f => !f.deleted_by && !f.deleted_date);
  }

  static async storeFeedItems(projectId: string, items: FeedItemDoc[]): Promise<FeedItemDoc[]> {
    const db = ConcourseDb.getInstance(`p-${projectId}-feed`);
    return (await db.saveDocs(items)) as FeedItemDoc[];
  }

  static sortByDateAsc = (a: FeedItemDoc, b: FeedItemDoc) => (a.date < b.date ? -1 : a.date > b.date ? 1 : 0);
  static sortByDateDesc = (a: FeedItemDoc, b: FeedItemDoc) => (a.date > b.date ? -1 : a.date < b.date ? 1 : 0);
}
